import { Envelope, Telephone } from "react-bootstrap-icons";
import { HashLink as Link } from "react-router-hash-link";
import { SectionCard } from "./SectionCard";
import styles from "./SupportSection.module.scss";
import { TutorialButton } from "./TutorialButton";

export function SupportSection() {
  return (
    <SectionCard
      id="support"
      ariaLabelledby="support-h"
      title="Support — We've Got You"
      description="Reach out to the Briefpoint team."
    >
      <div className={styles.support}>
        {/* Contact card */}
        <div className={styles.card}>
          <h3 id="support-contact-h">Contact</h3>

          <div className={styles.contactBlock}>
            <a
              className={styles.contactEmail}
              href="mailto:support@briefpoint.ai"
              aria-label="Email support at support@briefpoint.ai"
            >
              <Envelope />
              support@briefpoint.ai
            </a>

            <a
              className={styles.contactPhone}
              href="tel:+14155286928"
              aria-label="Call support at 415.528.6928"
            >
              <Telephone />
              Call: 415.528.6928
            </a>
          </div>

          <div className={styles.btnRow}>
            <TutorialButton
              to="https://calendly.com/d/cxth-mw8-8qq/briefpoint-training"
              offsite
              size="sm"
              variant="primary"
            >
              Use the training calendar
            </TutorialButton>
            <TutorialButton to="#videos" size="sm" variant="outline">
              Browse training videos
            </TutorialButton>
          </div>
        </div>

        {/* Helpful links */}
        <div className={styles.card}>
          <h3 id="support-links-h">Helpful Links</h3>
          <ul className={styles.linklist}>
            <li>
              <Link to="#videos" smooth>
                <span className={styles.chip}>▶</span>
                <span>All training videos</span>
              </Link>
            </li>
            <li>
              <Link to="#tutorials" smooth>
                <span className={styles.chip}>✓</span>
                <span>Step-by-step guides</span>
              </Link>
            </li>
            <li>
              <Link to="#autodoc" smooth>
                <span className={styles.chip}>A</span>
                <span>Autodoc instructions</span>
              </Link>
            </li>
            <li>
              <Link to="#troubleshooting" smooth>
                <span className={styles.chip}>!</span>
                <span>Troubleshooting tips</span>
              </Link>
            </li>
            <li>
              <Link to="#training" smooth>
                <span className={styles.chip}>★</span>
                <span>Schedule a team training</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </SectionCard>
  );
}
